var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"flex-basis":"100%"}},[_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c(_vm.currentView,{tag:"component",attrs:{"form":_vm.form,"mode":_vm.mode},on:{"set-selection-onto-map":function($event){return _vm.$emit('set-selection-onto-map', $event)}}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }